// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../resources/layout-and-structure/Box.res.js";
import * as Auth from "../bundles/Auth/Auth.res.js";
import * as I18n from "../primitives/I18n.res.js";
import * as React from "react";
import * as AuthRoutes from "../app/Auth/AuthRoutes.res.js";
import * as Navigation from "../primitives/Navigation.res.js";
import * as NextBanner from "../resources/feedback-indicators/NextBanner.res.js";
import * as JsxRuntime from "react/jsx-runtime";

let legacyHostname = "dashboard.wino.fr";

let appHostname = "app.wino.fr";

let searchParam = "fromLegacyDashboard";

function redirect() {
  let url = new URL(window.location.href);
  if (url.hostname === legacyHostname) {
    url.hostname = appHostname;
    url.searchParams.set(searchParam, "true");
    window.location.replace(url.toString());
    return true;
  } else {
    return false;
  }
}

let url = new URL(window.location.href);

let fromLegacyDashboard = url.searchParams.has(searchParam);

let bannerOpened = {
  contents: (fromLegacyDashboard ? (url.searchParams.delete(searchParam), history.replaceState(null, "", url.toString()), undefined) : undefined, fromLegacyDashboard)
};

let bannerListeners = {
  contents: []
};

function subscribeBanner(listener) {
  bannerListeners.contents = bannerListeners.contents.concat([listener]);
  return () => {
    bannerListeners.contents = bannerListeners.contents.filter(other => other !== listener);
  };
}

function closeBanner() {
  bannerOpened.contents = false;
  bannerListeners.contents.forEach(listener => listener());
}

function useBanner() {
  let match = Navigation.useUrl();
  let pathname = match.pathname;
  let auth = Auth.useState();
  let firstLoggedPathname = React.useRef(undefined);
  React.useEffect(() => {
    if (typeof auth === "object" && auth.TAG !== "Logging" && pathname !== "/" && !pathname.startsWith(AuthRoutes.baseRoute)) {
      let firstPathname = firstLoggedPathname.current;
      if (firstPathname !== undefined) {
        if (firstPathname !== pathname) {
          closeBanner();
        }
      } else {
        firstLoggedPathname.current = pathname;
      }
    }
  }, [
    pathname,
    auth
  ]);
  return [
    React.useSyncExternalStore(subscribeBanner, () => bannerOpened.contents),
    closeBanner
  ];
}

function LegacyDashboard$Banner(props) {
  let match = useBanner();
  if (match[0]) {
    return JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(NextBanner.make, {
        children: JsxRuntime.jsx(NextBanner.Text.make, {
          text: I18n.t("legacy_dashboard_notice_banner.text")
        }),
        variation: "info",
        title: I18n.t("legacy_dashboard_notice_banner.title"),
        onRequestClose: match[1]
      }),
      spaceX: props.spaceX,
      spaceTop: props.spaceTop,
      style: {
        width: "100%"
      }
    });
  } else {
    return null;
  }
}

let Banner = {
  make: LegacyDashboard$Banner
};

export {
  legacyHostname,
  appHostname,
  searchParam,
  redirect,
  bannerOpened,
  bannerListeners,
  subscribeBanner,
  closeBanner,
  useBanner,
  Banner,
}
/* bannerOpened Not a pure module */
